import { migrateV1ToV2 } from './migrations/v1_to_v2';

export function migrateResume(resume) {
  if (!resume) return resume;
  let next = JSON.parse(JSON.stringify(resume));

  const currentVersion = next.schemaVersion || 1;

  if (currentVersion === 1) {
    next = migrateV1ToV2(next);
  }

  return next;
}
